import ShippingOption from './ShippingOption';
import { useLoaderData } from '@remix-run/react';
import type { ItemShippingType } from '@modules/ecommerce/context/ItemShippingContext';
import { makeShippingOption } from '@modules/ecommerce/context/ItemShippingContext';
import type { ProductPageLoaderData } from '~/routes/_app.product.$urlSegment';

interface Props {
    shipping: ItemShippingType | null;
    onChange: (shipping: ItemShippingType) => void;
}

const ClickAndCollectSelect = ({ shipping, onChange }: Props) => {
    const { product } = useLoaderData<ProductPageLoaderData>();

    const pickupLocation = product.Professional?.PickupLocations ?? [];
    const selectedID =
        shipping && shipping.type === 'clickAndCollect' && shipping.ID;

    return (
        <div>
            <h3 className="mb-3 text-sm font-semibold tracking-normal">
                Click &amp; Collect
            </h3>
            {pickupLocation.map((l) => (
                <ShippingOption
                    key={'pickup-location-' + l.ID}
                    selected={l.ID === selectedID}
                    title={l.Title}
                    subTitle={
                        <span>
                            {l.PickupEstimateText}
                            <br />
                            {l.FormattedAddress}
                        </span>
                    }
                    onClick={() =>
                        onChange(makeShippingOption('clickAndCollect', l.ID))
                    }
                />
            ))}
        </div>
    );
};

export default ClickAndCollectSelect;
